import { API, APP_URLS, clientNeoAuth } from "@neonumy/api-clients";
import { Header, validateId } from "@neonumy/neonumy-ui";
import { UserDataType } from "@neonumy/neonumy-ui/lib/components/Header/Header";
import { Layout } from "antd";
import axios from "axios";
import { routes } from "config/routes";
import usePermissions from "hooks/usePermissions";
import useUserDataStore from "hooks/useUserDataStore";
import Cookies from "js-cookie";
import isEqual from "lodash-es/isEqual";
import React from "react";
import { useParams } from "react-router-dom";
import Logo from "resources/images/logo.svg?react";
import { Params } from "types/common";
import { isNewraiUser } from "utils/isNewraiUser";
import useBulkStore from "views/Bulk/hooks/useBulkStore";
import useCompanyFiltersStore from "views/Home/hooks/useCompanyFiltersStore";

function ApplicationWrapper() {
  const userData = useUserDataStore(state => state.userData);
  const resetStore = useUserDataStore(state => state.resetStore);
  const companySelected = useBulkStore(state => state.company);
  const companyFilters = useCompanyFiltersStore(state => state.companyFilters);
  const { isATC } = usePermissions();

  const { companyId: companyIdFromURL }: Params = useParams();

  const handleLogout = async () => {
    const resetStores = (): void => {
      clientNeoAuth.resetStore();
      resetStore();
    };

    const resetCookies = (): void => {
      Cookies.remove("access_token");
      Cookies.remove("expireDate");
    };

    await axios(API.revokeToken, {
      method: "post",
      data: `token=${Cookies.get("access_token")}&client_id=${API.clientId}`,
    }).then(() => {
      resetStores();
      resetCookies();
      routes.navigate("/", { replace: true });
    });
  };

  const canUpdateCompany =
    userData?.permissions &&
    userData.permissions.find((item: string) => item === "central-api.can-update-companies");

  const user: UserDataType = {
    firstName: userData.firstName,
    lastName: userData.lastName,
    email: userData.email,
    category: userData.userCategory.slug,
    isNewraiUser: isNewraiUser(userData),
  };

  const companyID = companyIdFromURL || companySelected?.id;

  return (
    <Layout>
      <Header
        appLogo={<Logo style={{ height: "30px" }} />}
        appName="NeoSSI"
        userData={user}
        companySelected={companySelected}
        userAvatar={{
          profileHref: `${APP_URLS.dashboardUrl}account/profile`,
          handleLogout: handleLogout,
        }}
        showNotifications
        {...(!isATC
          ? {
              appsUrlParams: {
                companyId: companySelected?.id || companyFilters?.id || companyIdFromURL,
                accountingFirmId:
                  companySelected?.accountingFirm?.id || companyFilters?.accountingFirm?.id,
              },
            }
          : { appsUrlParams: {} })}
        {...(canUpdateCompany &&
          validateId(companyID) && {
            dashboardCompanyUrl: `${APP_URLS.dashboardUrl}companies/${companyID}/general/info`,
          })}
      />
    </Layout>
  );
}

export default React.memo(ApplicationWrapper, (prevProps, nextProps) => {
  return isEqual(prevProps, nextProps);
});
